import React from 'react';

/**
 * Input — BRAND.md §8.5. Label ABOVE the field (never placeholder-as-label).
 * Error = danger border + caption message wired via aria-describedby.
 * `dirValue="ltr"` forces LTR entry (phone/OTP) even in an Arabic UI.
 */
export function Input({
  label, hint, error, id, required = false, dirValue,
  prefixIcon, style, ...rest
}) {
  const autoId = React.useId();
  const inputId = id || autoId;
  const descId = (error || hint) ? inputId + '-desc' : undefined;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}>
      {label && (
        <label htmlFor={inputId} style={{
          fontFamily: 'var(--font-body)', fontSize: 14, fontWeight: 600,
          color: 'var(--sedra-ink)',
        }}>
          {label}{required && <span style={{ color: 'var(--status-danger)' }}> *</span>}
        </label>
      )}
      <input
        id={inputId}
        aria-invalid={!!error}
        aria-describedby={descId}
        dir={dirValue}
        style={{
          width: '100%', padding: '10px 13px', boxSizing: 'border-box',
          borderRadius: 'var(--radius-sm)', fontSize: 14,
          fontFamily: 'var(--font-body)', color: 'var(--sedra-ink)',
          background: 'var(--sedra-card)', outline: 'none',
          border: error ? '1px solid var(--status-danger)' : '1px solid var(--sedra-line)',
          transition: 'border-color var(--motion-micro)',
        }}
        {...rest}
      />
      {(error || hint) && (
        <span id={descId} style={{
          fontFamily: 'var(--font-body)', fontSize: 12,
          color: error ? 'var(--status-danger)' : 'var(--sedra-ink-muted)',
        }}>{error || hint}</span>
      )}
    </div>
  );
}
